#import "../fragments/products-for-lead-fragment.graphql"

query GetProductsForLead($leadId: ID!) {
    lead(id: $leadId) {
        ...ProductsForLeadFragment
    }
}
